import { css } from 'aphrodite';
import { useId } from 'react';
import {
	CustomerAssistantAvatar,
	CustomerAssistantConversationStarterCard,
	CustomerAssistantConversationStarters,
	CustomerAssistantDescription,
	CustomerAssistantTitle,
} from '../../CustomerAssistantUI';
import { previewWidgetStyles } from './AssistantPreviewWidget.styles';

interface AssistantPreviewWidgetProps {
	name: string;
	description: string;
	avatarUrl: string | null;
	conversationStarters: string[];
}

export function AssistantPreviewWidget({
	name,
	description,
	avatarUrl,
	conversationStarters,
}: AssistantPreviewWidgetProps) {
	// Filter out empty starters for preview
	const nonEmptyStarters = conversationStarters.filter(s => s.trim());
	const id = useId();

	return (
		<div className={css(previewWidgetStyles.container)}>
			<div className={css(previewWidgetStyles.content)}>
				{avatarUrl ? <CustomerAssistantAvatar imgSrc={avatarUrl} /> : null}
				<CustomerAssistantTitle styles={[previewWidgetStyles.name, !name && previewWidgetStyles.namePlaceholder]}>
					{name || 'Assistant Name'}
				</CustomerAssistantTitle>
				<CustomerAssistantDescription
					styles={[previewWidgetStyles.description, !description && previewWidgetStyles.descriptionPlaceholder]}
				>
					{description || 'Assistant description will appear here...'}
				</CustomerAssistantDescription>
				{nonEmptyStarters.length > 0 && (
					<CustomerAssistantConversationStarters styles={[previewWidgetStyles.conversationStartersContainer]}>
						{nonEmptyStarters.map((starter, index) => (
							<CustomerAssistantConversationStarterCard key={`${id}-starter-${index}`}>
								{starter}
							</CustomerAssistantConversationStarterCard>
						))}
					</CustomerAssistantConversationStarters>
				)}
			</div>
		</div>
	);
}
